import { coreInitiativesFilesByIdDeleteAsyncSlice } from './delete';
import { coreInitiativesFilesByIdPatchAsyncSlice } from './patch';

export const { requestDeleteCoreInitiativesFilesById, resetDeleteCoreInitiativesFilesById } =
	coreInitiativesFilesByIdDeleteAsyncSlice.asyncActionCreators;

export const { requestPatchCoreInitiativesFilesById, resetPatchCoreInitiativesFilesById } =
	coreInitiativesFilesByIdPatchAsyncSlice.asyncActionCreators;
